import { ServiceTypes, Service } from '~/services/model/service.model'

export const serviceLiteralsByType = {
  [ServiceTypes.VOICE]: 'Voz',
  [ServiceTypes.VOICE_MAIL]: 'Buzón voz',
  [ServiceTypes.AVAILABILITY_NOTIFICATION]: 'Aviso de disponibilidad',
  [ServiceTypes.NUMBER_IDENTIFICATION]: 'Identificación de número',
  [ServiceTypes.CALL_FORWARDING]: 'Desvío de llamadas',
  [ServiceTypes.LANGUAGE]: 'Idioma',
  [ServiceTypes.CALLS_NOTIFICATION]: 'Aviso de llamadas',
  [ServiceTypes.INCOMING_CALLS_BLOCK]: 'Bloqueo de llamadas entrantes',
  [ServiceTypes.OUTGOING_CALLS_BLOCK]: 'Bloqueo de llamadas salientes',
  [ServiceTypes.OUTGOING_SMS]: 'Envío SMS',
  [ServiceTypes.INTERNET_3G]: 'GPRS',
  [ServiceTypes.ROAMING]: 'Roaming',
  [ServiceTypes.INCOMING_SMS]: 'Recibir SMS',
  [ServiceTypes.MMS]: 'MMS',
  [ServiceTypes.INTERNATIONAL_CALLS_BLOCK]: 'Bloqueo llamadas internacionales salientes',
  [ServiceTypes.PREMIUM_SERVICES]: 'Servicios Premium',
  [ServiceTypes.BLOCKS]: 'Bloqueos',
  [ServiceTypes.BARRINGS]: 'Barring IFS',
  [ServiceTypes.INTERNET_4G]: '4G (LTE)',
  [ServiceTypes.INTERNET_5G]: '5G',
  [ServiceTypes.INTERNET]: 'Internet',
  [ServiceTypes.SPEED]: 'Velocidad',
  [ServiceTypes.AWAITING_CALLS]: 'Llamada en espera',
  [ServiceTypes.THREE_PERSON_CALLS]: 'Llamada a tres',
  [ServiceTypes.BLOCK_SPECIAL_TARIFF_NUMBERS]: 'Bloqueo números tarificación especial',
  [ServiceTypes.DO_NOT_DISTURB]: 'No molestar',
  [ServiceTypes.FAX_TO_MAIL]: 'Fax to mail',
  [ServiceTypes.OFFICE_365]: 'Office 365',
  [ServiceTypes.FIXED_IP]: 'IP fija',
  [ServiceTypes.AVAILABLE_NETWORKS]: 'Redes disponibles',
}
export const getServiceName = (service: Service) => serviceLiteralsByType[service.id] || service.id
